import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { Archetype, Lego } from '@domain/models/task/task';
import { ExecutionResponse } from '@domain/models/execution/execution-response';
import { PreviewInputsViewModel } from '@view/executions/pages/wizard/wizard.viewmodel';

@Injectable({
  providedIn: 'root'
})
export class WizardService {
  private readonly previewTaskListener = new BehaviorSubject<
    (Lego | Archetype)[]
  >([]);
  private readonly restartExecution$ = new Subject<boolean>();
  private executionListener: ExecutionResponse = {} as ExecutionResponse;
  private readonly actionLoading$ = new BehaviorSubject<boolean>(false);

  private readonly previewInputs$ =
    new BehaviorSubject<PreviewInputsViewModel | null>(null);

  setPreviewTasks(previewTasks: (Lego | Archetype)[]) {
    previewTasks.sort((a, b) => a.name.length - b.name.length);
    this.previewTaskListener.next(previewTasks);
  }

  getPreviewTasks() {
    return this.previewTaskListener.asObservable();
  }

  setPreviewInputs(inputs: PreviewInputsViewModel): void {
    this.previewInputs$.next(inputs);
  }

  getPreviewInputs() {
    return this.previewInputs$.asObservable();
  }

  setExecutionListener(execution: ExecutionResponse) {
    this.executionListener = execution;
  }

  getExecutionListener() {
    return this.executionListener;
  }

  notifyRestartExecution() {
    this.restartExecution$.next(true);
  }

  watchRestartExecution() {
    return this.restartExecution$.asObservable();
  }

  notifyActionLoading() {
    this.actionLoading$.next(true);
  }

  notifyActionLoaded() {
    this.actionLoading$.next(false);
  }

  watchActionLoading() {
    return this.actionLoading$.asObservable();
  }
}
